/** Excludes loading work and already scheduled animation timestamps after a reset. */
export class FrameClock {
  private last: number | null = null;
  private notBefore = -Infinity;

  reset(now: number): void {
    this.last = null;
    this.notBefore = now;
  }

  sample(time: number): number | null {
    if (time < this.notBefore) return null;
    const delta = this.last === null ? 0 : Math.max(0, time - this.last);
    this.last = time;
    return delta;
  }
}
